import(/* webpackMode: "eager" */ "/opt/render/project/src/client/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/client/components/AppProviders.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/client/components/BottomNav.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/client/components/ClientRuntime.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/client/components/Footer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/client/components/GlobalLoader.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/client/components/MainWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/client/components/Navbar.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/client/components/ToastProvider.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/client/node_modules/next/font/google/target.css?{\"path\":\"app/layout.js\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\"],\"variable\":\"--font-body\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/client/node_modules/next/font/google/target.css?{\"path\":\"app/layout.js\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"600\"],\"variable\":\"--font-heading\"}],\"variableName\":\"montserrat\"}");
